// Angular
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { Http, RequestOptions } from '@angular/http';
// Angular Material
import {
  MatAutocompleteModule,
  MatDatepickerModule, 
  MatNativeDateModule, 
  MatInputModule,
  MatDialogModule,
  MatTooltipModule,
  MatSlideToggleModule
} from '@angular/material';

// Moduli Installati
import { FileUploadModule } from 'ng2-file-upload';
import { Ng2CompleterModule } from 'ng2-completer';
import { AuthHttp, AuthConfig } from 'angular2-jwt';
import { RecaptchaModule, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { AgmCoreModule } from '@agm/core';
import { BootstrapSwitchModule } from 'angular2-bootstrap-switch'; 
import { CookieService } from 'ngx-cookie-service';
import { EmbedVideo } from 'ngx-embed-video';
// Moduli Modificati
import { NgBootstrapFormValidationModule } from 'ng-bootstrap-form-validation';

// Moduli Creati
import { UtilitaModule } from './components/utilita/utilita.module';

// Componenti, Pipe ...
import { AppComponent } from './app.component';
import { MenuComponent } from './components/menu/menu.component';
import { AlertComponent } from './components/utilita/alert/alert.component';
import { PageNotFoundComponent } from './components/area-generale/page-not-found/page-not-found.component';
import { DialogCookieConfirm } from './components/utilita/dialogs/dialog-cookie-confirm/dialog-cookie-confirm.component';
import { DialogPrivacy } from './components/utilita/dialogs/dialog-privacy/dialog-privacy.component';
import { DialogTerminiUtilizzo } from './components/utilita/dialogs/dialog-termini-utilizzo/dialog-termini-utilizzo.component';
import { DialogLogin } from './components/utilita/dialogs/dialog-login/dialog-login.component';
import { ImpostazioneCookieComponent } from './components/utilita/impostazione-cookie/impostazione-cookie.component';
import { CUSTOM_ERRORS } from './custom-global-errors';

// Servizi 
import { MainService } from './services';
import { AlertService } from './services/alert.service';
import { ComuneService } from './services/comune.service';
import { FileService } from './services/file.service';
import { CollaboratoreService } from './services/collaboratore.service';
import { TrascodificaService } from './services/trascodifica.service';
import { AuthenticationService } from './services/authentication.service';
import { BackOfficeService } from './services/back-office.service';
import { ProfiloService } from './services/profilo.service';
import { ImmobiliareService } from './services/immobiliare.service';
import { PagerService } from './services/pager.service';
import { ServizioImmobileService } from './services/servizio-immobile.service';
import { ServizioAcquirenteService } from './services/servizio-acquirente.service';
import { MessaggioService } from './services/messaggio.service';
import { CartService } from './services/cart.service';
import { MyCookieService } from './services/my-cookie.service';
import { ProvinciaService } from './services/provincia.service';
import { CapService } from './services/cap.service';
import { EmailTemplateService } from './services/email-template.service';
import { BloccoImmobileService } from './services/blocco-immobile.service';
import { PagamentoService } from './services/pagamento.service';
import { OrarioService } from './services/orario.service';
import { ImpostazioniService } from './services/impostazioni.service';
import { RegistrazioneService } from './services/registrazione.service';
import { AnagraficaService } from './services/anagrafica.service';
import { ResetPasswordService } from './services/reset-password.service';
import { TokenExpiredService } from './services/token-expired.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { environment } from 'environments/environment';
import { RichiestaMutuoService } from './services/richiesta-mutuo.service';
// Configurazione JWT
export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    headerName: environment.headerName,
    noTokenScheme: true,
    tokenName: environment.tokenName,
    noJwtError: true,
    tokenGetter: (() => localStorage.getItem(environment.tokenName)),
    globalHeaders: [{ 'Content-Type': 'application/json' }],
    
  }), http, options);
}

let routing = 
[          
  {                 
    path: '',                
    loadChildren: 'app/components/area-generale/area-generale.module#AreaGeneraleModule',
    data: { preload: true }
  },
  {                 
    path: 'area_utente',               
    loadChildren: 'app/components/area-utente/area-utente.module#AreaUtenteModule',
    data: { preload: false }                         
  },
  {                 
    path: '**',                
    component: PageNotFoundComponent                       
  }
]

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    AlertComponent,
    DialogPrivacy,
    DialogTerminiUtilizzo,
    DialogCookieConfirm,
    DialogLogin,
    PageNotFoundComponent,
    ImpostazioneCookieComponent,
  ],
  entryComponents: [
    DialogPrivacy,
    DialogTerminiUtilizzo,
    DialogCookieConfirm,
    DialogLogin
  ],
  imports: [
    RouterModule.forRoot(routing),
    BrowserModule,
    BootstrapSwitchModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    Ng2CompleterModule,
    RouterModule,
    FileUploadModule,
    RecaptchaModule.forRoot(),
    NgBootstrapFormValidationModule.forRoot(CUSTOM_ERRORS),
    RecaptchaFormsModule,
    MatAutocompleteModule,
    MatDatepickerModule, 
    MatNativeDateModule, 
    MatInputModule,
    MatDialogModule,
    MatTooltipModule,
    MatSlideToggleModule,
    BrowserAnimationsModule,
    EmbedVideo.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyA7TJsTDdi9kQOqnUW7Ngyiwb5KCiSUaHc'
    }),
    UtilitaModule
  ],
  providers: [
    ProvinciaService,
    CapService,
    MainService,
    AlertService,
    TrascodificaService,
    AuthenticationService,
    BackOfficeService,
    CollaboratoreService,
    ComuneService,
    FileService,
    ProfiloService,
    ImmobiliareService,
    PagerService,
    MessaggioService,
    CartService,
    MyCookieService,
    EmailTemplateService,
    ServizioImmobileService,
    ServizioAcquirenteService,
    BloccoImmobileService,
    RichiestaMutuoService,
    PagamentoService,
    OrarioService,
    CookieService,
    ImpostazioniService,
    RegistrazioneService,
    AnagraficaService,
    ResetPasswordService,
    TokenExpiredService,
    GoogleAnalyticsService,
    { // lingua del reCaptcha
      provide: RECAPTCHA_LANGUAGE,
      useValue: 'it'
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6LefhygUAAAAAJYKSxEfeFaMT-u6ZIOBYVBv-bju' } as RecaptchaSettings,
    },
    { // lingua dell'app
      provide: LOCALE_ID,
      useValue: 'it-IT'
    },
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    }
  ],
  exports: [
    DialogLogin
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/app.module.ts